module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "maxWidth": '500px'
    },
    on: {
      "close": _vm.handleModalClose
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleModalClose.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-5 h-full flex flex-col items-center justify-center"
  }, [_c('div', [_c('img', {
    staticClass: "upgrade-image",
    attrs: {
      "src": "/static/stick_men/disco.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pl-subheading"
  }, [_vm._v("Welcome to the\n        "), _c('span', {
    staticClass: "primary"
  }, [_c('strong', [_vm._v("Parlay")])]), _vm._v(" Family!")])]), _vm._v(" "), _c('div', {
    staticClass: "center-xs pl-subheading"
  }, [(_vm.school_info) ? [(_vm.teacher_count <= 1) ? _c('span', [_vm._v("\n          You are the\n          "), _c('span', {
    staticClass: "secondary"
  }, [_c('strong', [_vm._v("first")])]), _vm._v("\n          teacher using Parlay at\n          "), _c('span', {
    staticClass: "primary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.school_name))])]), _vm._v("!\n        ")]) : _c('span', [_vm._v("\n          There are now\n          "), _c('span', {
    staticClass: "secondary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.teacher_count))])]), _vm._v("\n          teachers using Parlay at\n          "), _c('span', {
    staticClass: "primary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.school_name))])]), _vm._v("!\n        ")])] : [_c('div', {
    staticClass: "flex flex-col justify-center"
  }, [_c('p', [_vm._v("You have unlimited classes on Parlay!")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('dashboard')
      }
    }
  }, [_vm._v("\n            Go to my dashboard\n          ")])], 1)]], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6f34b240!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/upgradeSuccessModal/upgradeSuccessModal.vue
// module id = 2400
// module chunks = 61